export default "__VITE_ASSET__BDqY$C12__"